// admins/{uid} 문서는 클라이언트가 절대 직접 쓸 수 없다(firestore.rules: allow write: if false) —
// functions/api/admin/admins.js가 서비스 계정 경로로만 갱신하고 custom claim 동기화·refresh token
// revoke·audit log 기록까지 전부 처리하는 유일한 진입점이다. 이 파일은 그 API를 부르기만 한다.
const ERROR_MESSAGES = {
  missing_token: '로그인이 필요합니다.',
  invalid_token: '로그인이 만료되었습니다. 다시 로그인해 주세요.',
  reauth_required: '보안을 위해 최근 로그인이 필요합니다. 다시 로그인한 뒤 다시 시도해 주세요.',
  forbidden: '권한이 없습니다.',
  insufficient_role: 'owner 권한이 필요합니다.',
  claim_not_synced: '계정 권한 동기화가 아직 완료되지 않았습니다.',
  invalid_target_uid: '올바른 UID 형식이 아닙니다.',
  cannot_disable_self: '자기 자신의 계정은 비활성화할 수 없습니다.',
  invalid_role_assignment: '입력값을 확인하세요(UID/역할/표시 이름).',
  cannot_demote_self: '자기 자신의 역할은 낮출 수 없습니다(owner가 아무도 없어지는 사고 방지).',
  invalid_action: '알 수 없는 요청입니다.',
}

async function callAdminsApi(method, token, body) {
  const response = await fetch('/api/admin/admins', {
    method,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(ERROR_MESSAGES[data?.code] || data?.code || `요청에 실패했습니다 (${response.status})`)
  return data
}

export async function fetchAdminAccounts(token) {
  const data = await callAdminsApi('GET', token)
  return data.accounts ?? []
}

export async function setAdminRoleRemote(token, { targetUid, role, displayName }) {
  return callAdminsApi('POST', token, { action: 'setRole', targetUid, role, displayName })
}

export async function disableAdminAccountRemote(token, targetUid) {
  return callAdminsApi('POST', token, { action: 'disable', targetUid })
}
